import { render, staticRenderFns } from "./knowledge-base.vue?vue&type=template&id=14dccf72&scoped=true&"
import script from "./knowledge-base.vue?vue&type=script&lang=js&"
export * from "./knowledge-base.vue?vue&type=script&lang=js&"
import style0 from "./knowledge-base.vue?vue&type=style&index=0&id=14dccf72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dccf72",
  null
  
)

export default component.exports